import React from 'react'
import styles from './clientAddress.scss'
import Input from './input'
import { SearchableSelectWrapper } from '../components/shared/select/SelectWrap'
import BpostSelect from './bpostSelect'
import moment from 'moment'
import {dateFormatter} from 'lib/helpers'

import underscore from 'underscore'
import i18n from 'lib/i18n'
const _ = i18n('clients')


export default class ClientAddressList extends React.Component {
    constructor(props) {
        super(props)
    }

    onBlurSetCountry(field) {
      const { data, addType, dispatch } = this.props

      if(addType == 'corressadd' && field.name != 'detail.correspondanceAddress.country')
      {
          if(this.emptyCheckAddressValues(data) == false)
          {
              if(data.country.value == undefined || data.country.value == "" || typeof data.country.value == 'object')
              {
                dispatch({
                  type: "redux-form/CHANGE",
                  field: data.country.name,
                  value: "1",
                  touch: true,
                  form: "clientProfileEdit"
                })

                dispatch({
                  type:"redux-form/CHANGE",
                  field:data.postalCode.name,
                  value: "",
                  touch: true,
                  form: "clientProfileEdit"
                })

                dispatch({
                  type:"redux-form/CHANGE",
                  field:data.locality.name,
                  value: "",
                  touch: true,
                  form: "clientProfileEdit"
                })
              }
          }
      }

      dispatch({
          type: "redux-form/BLUR",
          field: field.name,
          value: field.value,
          touch: true,
          form: "clientProfileEdit"
      })

      // Clean zipCity or postalCode and locality based on country data
      if(field.name == 'detail.correspondanceAddress.country')
      {
        if(Number(field.value) == 1)
        {
          dispatch({
            type:"redux-form/CHANGE",
            field:data.postalCode.name,
            value: "",
            touch: true,
            form: "clientProfileEdit"
          })

          dispatch({
            type:"redux-form/CHANGE",
            field:data.locality.name,
            value: "",
            touch: true,
            form: "clientProfileEdit"
          })
        }
        else if(typeof field.value == 'object' || field.value == undefined || field.value == '')
        {
          dispatch({
            type:"redux-form/CHANGE",
            field:data.postalCode.name,
            value: "",
            touch: true,
            form: "clientProfileEdit"
          })

          dispatch({
            type:"redux-form/CHANGE",
            field:data.locality.name,
            value: "",
            touch: true,
            form: "clientProfileEdit"
          })
          dispatch({
            type:"redux-form/CHANGE",
            field:data.zipCity.name,
            value: "_",
            touch: true,
            form: "clientProfileEdit"
          })
        }
        else
        {
          dispatch({
            type:"redux-form/CHANGE",
            field:data.zipCity.name,
            value: "_",
            touch: true,
            form: "clientProfileEdit"
          })
        }
      }
    }

    /**
     * Checks if the correspondance address has already values
     * If there is any value then will return false
     */
    emptyCheckAddressValues(data)
    {
       let response = true

        Object.keys(data).map((key) => {
            if(key != 'zipCity')
            {
              if(data[key].value != undefined && data[key].value != "" && data[key].value != "_" )
              {
                response = false
              }
            }
            else
            {
              if(data[key].value != undefined && data[key].value != "")
              {
                response = false
              }
            }
        })

        return response
    }


    // Reset fields in case of corressadd requested by Silke BEWB-278
    resetDataClick(ev)
    {
      const {data, dispatch } = this.props

      Object.keys(data).forEach(key=>{
        dispatch({
          type:"redux-form/CHANGE",
          field: data[key].name,
          value: "",
          form: "clientProfileEdit"
        })

      })
    }

    getIcon() {
      try {
          return require(`resources/images/a-trash_1x_ovbBlue.svg`)
      } catch(err) {
          return require(`resources/images/icn-no-result.svg`)
      }
    }

    render() {
        const {data, countryOptions, title, addType} = this.props

        let isNotBelgiumSelected = data.country.value == 1 ? true : false
        let cityZip = null;

        if (isNotBelgiumSelected == true) {
            cityZip = <div>
                <label>{_('city')}{(addType == 'mainaddress') ? " *" : ""}</label>
                <BpostSelect {...data.zipCity} onBlur={() => {
                  this.onBlurSetCountry(data.zipCity)
                }} />
                {data != undefined && data.zipCity.error && data.zipCity.touched &&
                < div className={ styles.error }> { data.zipCity.error } </div> }
            </div>
        }
        else {
            cityZip = <div className={styles.multiFields2}>
                <div>
                    <label>{_('zip')}{(addType == 'mainaddress') ? " *" : ""}</label>
                    <input type="text" {...data.postalCode} onBlur={() => {
                      this.onBlurSetCountry(data.postalCode)
                    }}/>
                    {data != undefined && data.postalCode.error && data.postalCode.touched &&
                    < div className={ styles.error }> { data.postalCode.error } </div> }
                </div>
                <div>
                    <label>{_('city')}{(addType == 'mainaddress') ? " *" : ""}</label>
                    <input type="text" {...data.locality} onBlur={() => {
                      this.onBlurSetCountry(data.locality)
                    }} />
                    {data != undefined && data.locality.error && data.locality.touched &&
                    < div className={ styles.error }> { data.locality.error } </div> }
                </div>
            </div>
        }

        return (
            <div className={styles.moduleSection}>
                <div className={styles.clientsTableContainer}>
                  <div>
                    <h3>{title} {addType === 'corressadd' && 
                      <button type="button" className={styles.removeFieldsButton} onClick={event => {
                          event.preventDefault()
                          this.resetDataClick(event)
                          }}>
                          <img src={this.getIcon()}/>
                      </button> }
                    </h3>                    
                  </div>
                    <div>
                        <label>{_('country')}{(addType == 'mainaddress') ? " *" : ""}</label>
                        <SearchableSelectWrapper {...data.country} options={countryOptions} isSearchable isClearable onBlur={() => {
                          this.onBlurSetCountry(data.country)
                        }} />
                        {data != undefined && data.country.error && data.country.touched &&
                        < div className={ styles.error }> { data.country.error } </div> }
                    </div>
                    <div className={styles.multiFields}>

                        <div className={styles.streetDiv}>
                            <label>{_('street')}{(addType == 'mainaddress') ? " *" : ""}</label>
                            <input type="text" {...data.street} onBlur={() => {
                              this.onBlurSetCountry(data.street)
                            }} />
                            {data != undefined && data.street.error && data.street.touched &&
                            < div className={ styles.error }> { data.street.error } </div> }
                        </div>

                        <div className={styles.smallDivsInput}>
                            <label>{_('number')}{(addType == 'mainaddress') ? " *" : ""}</label>
                            <input type="text" {...data.number} onBlur={() => {
                              this.onBlurSetCountry(data.number)
                            }} />
                            {data != undefined && data.number.error && data.number.touched &&
                            < div className={ styles.error }> { data.number.error } </div> }
                        </div>


                        <div className={styles.smallDivsInput}>
                            <label>{_('bus')}</label>
                            <input type="text" {...data.extension} onBlur={() => {
                              this.onBlurSetCountry(data.bus)
                            }} />
                            {data != undefined && data.extension.error && data.extension.touched &&
                            < div className={ styles.error }> { data.extension.error } </div> }
                        </div>
                    </div>


                    <div>
                        {cityZip}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/clientAddressList.jsx